import { render, staticRenderFns } from "./reservationInfo.vue?vue&type=template&id=28608e7c&scoped=true"
import script from "./reservationInfo.vue?vue&type=script&lang=js"
export * from "./reservationInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28608e7c",
  null
  
)

export default component.exports